import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

function Exclusions() {
  const [list, setList] = useState([]);
  const [v, setV] = useState("");
  const load = () => api.get("/prospect/exclusions").then(({ data }) => setList(data));
  useEffect(() => { load(); }, []);
  const add = async () => {
    try { await api.post("/prospect/exclusions", { value: v }); setV(""); load(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="space-y-2 rounded-2xl border border-border p-4" data-testid="exclusions">
      <h3 className="font-display font-bold">Lista de exclusão</h3>
      <div className="flex gap-2"><Input placeholder="Telefone, email ou nome do negócio" value={v} onChange={(e) => setV(e.target.value)} data-testid="exclusion-input" />
        <Button onClick={add} disabled={v.length < 3} data-testid="exclusion-add-btn">Adicionar</Button></div>
      <ul className="divide-y text-sm">{list.map((x) => (
        <li key={x.id} className="flex items-center justify-between py-1.5"><span>{x.label} <span className="text-muted-foreground">· {x.reason}</span></span>
          <Button variant="ghost" size="icon" onClick={() => api.delete(`/prospect/exclusions/${x.id}`).then(load)}><Trash /></Button></li>
      ))}</ul>
    </div>
  );
}

export function ProspectSettings() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/prospect/settings").then(({ data }) => setF(data)); }, []);
  if (!f) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    try {
      const { data } = await api.put("/prospect/settings", { ...f, daily_limit: Number(f.daily_limit), score_threshold: Number(f.score_threshold) });
      setF(data);
      toast.success("Definições guardadas");
    } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <div className="space-y-3 rounded-2xl border border-border p-4" data-testid="prospect-settings">
        <h3 className="font-display font-bold">Definições</h3>
        <Label>Chave Google Places {f.places_configured ? "(configurada)" : "(em falta)"}</Label>
        <Input value={f.places_key} onChange={set("places_key")} placeholder="AIza…" data-testid="set-places-key" />
        <Label>Chave PageSpeed Insights {f.pagespeed_configured ? "(configurada)" : "(opcional)"}</Label>
        <Input value={f.pagespeed_key} onChange={set("pagespeed_key")} placeholder="AIza…" data-testid="set-pagespeed-key" />
        <Label>Assinatura</Label><Textarea rows={2} value={f.signature} onChange={set("signature")} data-testid="set-signature" />
        <Label>Link de agenda (chamada de 20 min)</Label><Input value={f.agenda_link} onChange={set("agenda_link")} placeholder="https://calendly.com/…" data-testid="set-agenda" />
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Envios por dia</Label><Input type="number" value={f.daily_limit} onChange={set("daily_limit")} data-testid="set-daily-limit" /></div>
          <div><Label>Nota mínima para avançar</Label><Input type="number" value={f.score_threshold} onChange={set("score_threshold")} data-testid="set-threshold" /></div>
        </div>
        <Button className="rounded-full" onClick={save} data-testid="settings-save-btn">Guardar</Button>
      </div>
      <Exclusions />
    </div>
  );
}
